import { createSelector } from "@reduxjs/toolkit";

import { parseSearchState, setSearchParams } from "@skydio/uri_util/src/query";

import { getSearchString } from "state/router";

import type { ThunkCreator } from "@skydio/redux_util/src";
import type { AppState } from "state/store";

export const convertToString = (param?: string | string[]) =>
  param ? (Array.isArray(param) ? param[0] : param) : "";

const parseQueryState = (searchString: string) =>
  parseSearchState<Record<string, string | string[]>, Record<string, string | string[]>>(
    searchString,
    {},
    params => params
  );

const parseQueryStateAsStringRecord = (searchString: string) =>
  parseSearchState<Record<string, string | string[]>, Record<string, string>>(
    searchString,
    {},
    params => Object.fromEntries(Object.entries(params).map(([k, v]) => [k, convertToString(v)]))
  );

export const getVariablesFromUrl = createSelector(getSearchString, searchString =>
  parseQueryStateAsStringRecord(searchString)
);

export const getVariablesFromUrlRaw = createSelector(getSearchString, searchString =>
  parseQueryState(searchString)
);

export const updateUrlParams: ThunkCreator<
  AppState,
  [Record<string, string | string[] | number | undefined>]
> = variables => (dispatch, getState) => {
  const existingParams = getVariablesFromUrl(getState());
  dispatch(setSearchParams({ ...existingParams, ...variables }));
};
